
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Flex,
  Button,
  Menu,
  MenuButton,
  MenuList,
  Checkbox, CheckboxGroup, VStack,
  Radio, RadioGroup,
  Input,
  Spinner
} from '@chakra-ui/react';
import moment from 'moment';
import { useCompany } from '../../../GlobalComponent/CompanyContext/CompanyContext';
import { useRef } from 'react';

function CustomTable({ data,  filters, setFilters, loading,total }: { data: any[];  filters: any; setFilters: any;loading:any,total:any }) {

  const menuButtonRef = useRef<HTMLButtonElement | null>(null);
  const menuStatusButtonRef=useRef<HTMLButtonElement | null>(null);

  
  const { company } = useCompany();
  const resetFilters = () => {
     setFilters({companyNames:[],ticketStatuses:[],ticketType:[],relationShipToSubscriber:[],startDate:"",endDate:""})
  };



  return (
    <Box p={5}>
      <Flex gap={4} flexWrap="wrap" align="flex-end" mb={4}>
        {/* Company Name Filter */}
        <Box minW="200px">
          <Text fontWeight="medium" mb={1}>Company Name</Text>
          <Menu closeOnSelect={false}>
            <MenuButton as={Button} width="100%" ref={menuButtonRef}>
              {filters?.companyNames?.length > 0
                ? filters?.companyNames[0]
                : 'All Companies'}
              
            </MenuButton>
            <MenuList p={0} minW="200px">
              <Box maxHeight="300px" overflowY="auto" px={0} py={2}>
                <RadioGroup
                  value={filters?.companyNames?.length > 0 ? filters?.companyNames[0] : ""}
                  onChange={(value) => {
                    if (value === "") {
                      setFilters((prev:any)=>({...prev,companyNames:[]}));
                    } else {
                      setFilters((prev:any)=>({...prev,companyNames:[value]}));
                    }
                  }}
                >
                  <VStack align="stretch" spacing={1}>
                    <Flex align="center" _hover={{ bg: 'gray.100' }}>
                      <Radio ml={3} value="">
                        <Text fontSize="sm" ml={4}>All Companies</Text>
                      </Radio>
                    </Flex>
                    {company?.data?.map((comp: any, index: number) => (
                      <Flex
                        key={comp?._id || `company-${index}`}
                        align="center"
                        _hover={{ bg: 'gray.100' }}
                      >
                        <Radio
                          ml={3}
                          value={comp?.companyName}
                        >
                          <Text fontSize="sm" ml={4}>{comp?.companyName}</Text>
                        </Radio>
                      </Flex>
                    ))}
                  </VStack>
                </RadioGroup>
              </Box>

              <Flex borderTop="1px solid #e2e8f0" px={3} py={2} bg="white" justifyContent={"space-between"}>
                <Button
                  bg="blue"
                  color="white"
                  variant="ghost"
                  size="sm"
                  _hover={{ bg: 'gray.100' }}
                  onClick={() => {
                    menuButtonRef.current?.click(); 
                  }}
                >
                  close
                </Button>
                 <Button
                  bg="blue"
                  color="white"
                  variant="ghost"
                  size="sm"
                  _hover={{ bg: 'gray.100' }}
                  onClick={()=>{
                     setFilters((prev: any) => ({
                                ...prev,
                                companyNames: [],
                              }))
                  }}
                >
                  reset
                </Button>
              </Flex>
            </MenuList>
          </Menu>
        </Box>

        {/* Ticket Status Filter */}
        <Box minW="200px">
          <Text fontWeight="medium" mb={1}>Ticket Status</Text>
          <Menu closeOnSelect={false}>
            <MenuButton as={Button} width="100%" ref={menuStatusButtonRef}>
              {filters?.ticketStatuses?.length > 0
                ? `${filters?.ticketStatuses?.length} Selected`
                : 'All Statuses'}
            </MenuButton>
            <MenuList p={0} minW="200px">
              <Box maxHeight="300px" overflowY="auto" px={0} py={2}>
                <CheckboxGroup
                  value={filters?.ticketStatuses}
                   onChange={(values) => setFilters((prev:any)=>({...prev,ticketStatuses:[...prev.ticketStatuses,values]}))}
                >
                  <VStack align="stretch" spacing={1}>
                    {[
                      'New',
                      'Work in progress',
                      'Completed',
                      'Cancelled',
                      
                    ].map((status) => (
                      <Flex key={status} align="center" _hover={{ bg: 'gray.100' }} >
                        <Checkbox
                          ml={3}
                          value={status}
                          isChecked={filters?.ticketStatuses?.includes(status)}
                          onChange={(e) => {
                            const value = status;
                            if (e.target.checked) {
                              setFilters((prev: any) => ({
                                ...prev,
                                ticketStatuses: [...filters?.ticketStatuses, value],
                              }));
                            } else {
                              setFilters((prev: any) => ({
                                ...prev,
                                ticketStatuses: filters?.ticketStatuses.filter((v: any) => v !== value),
                              }));
                            }
                          }}
                        />
                        <Text fontSize="sm" ml={4}>{status}</Text>
                      </Flex>
                    ))}
                  </VStack>
                </CheckboxGroup>
              </Box>

              <Flex borderTop="1px solid #e2e8f0" px={3} py={2} bg="white"  justifyContent="space-between">
                <Button
                  bg="blue"
                  color="white"
                  variant="ghost"
                  size="sm"
                  _hover={{ bg: 'gray.100' }}
                  onClick={() => {
                    menuStatusButtonRef.current?.click(); 
                  }}
                >
                  close
                </Button>
                 <Button
                  bg="blue"
                  color="white"
                  variant="ghost"
                  size="sm"
                  _hover={{ bg: 'gray.100' }}
                  onClick={()=>{
                     setFilters((prev: any) => ({
                                ...prev,
                                ticketStatuses: [],
                              }))
                  }}
                >
                  reset
                </Button>
              </Flex>
            </MenuList>
          </Menu>
        </Box>

         <Box minW="200px">
          <Text fontWeight="medium" mb={1}>Ticket Type</Text>
          <Menu closeOnSelect={false}>
            <MenuButton as={Button} width="100%" ref={menuStatusButtonRef}>
              {filters?.ticketType?.length > 0
                ? `${filters?.ticketType?.length} Selected`
                : 'All Ticket Types'}
            </MenuButton>
            <MenuList p={0} minW="200px">
              <Box maxHeight="300px" overflowY="auto" px={0} py={2}>
                <CheckboxGroup
                  value={filters?.ticketType}
                   onChange={(values) => setFilters((prev:any)=>({...prev,ticketType:values}))}
                >
                  <VStack align="stretch" spacing={1}>
                    {[
                      "GeneralEnquiry",
                      "TestDemo",
                      "Customer Test",
                      "Internal Test",
                      "emergencyTicket",
                      "Call By Senior",
                      "Ambulance Booking"
                    ].map((status) => (
                      <Flex key={status} align="center" _hover={{ bg: 'gray.100' }} >
                        <Checkbox
                          ml={3}
                          value={status}
                          isChecked={filters?.ticketType?.includes(status)}
                          onChange={(e) => {
                            const value = status;
                            if (e.target.checked) {
                              setFilters((prev: any) => ({
                                ...prev,
                                ticketType: [...filters?.ticketType, value],
                              }));
                            } else {
                              setFilters((prev: any) => ({
                                ...prev,
                                ticketType: filters?.ticketType.filter((v: any) => v !== value),
                              }));
                            }
                          }}
                        />
                        <Text fontSize="sm" ml={4}>{status}</Text>
                      </Flex>
                    ))}
                  </VStack>
                </CheckboxGroup>
              </Box>

              <Flex borderTop="1px solid #e2e8f0" px={3} py={2} bg="white"  justifyContent="space-between">
                <Button
                  bg="blue"
                  color="white"
                  variant="ghost"
                  size="sm"
                  _hover={{ bg: 'gray.100' }}
                  onClick={() => {
                    menuStatusButtonRef.current?.click(); 
                  }}
                >
                  close
                </Button>
                 <Button
                  bg="blue"
                  color="white"
                  variant="ghost"
                  size="sm"
                  _hover={{ bg: 'gray.100' }}
                  onClick={()=>{
                     setFilters((prev: any) => ({
                                ...prev,
                                ticketType: [],
                              }))
                  }}
                >
                  reset
                </Button>
              </Flex>
            </MenuList>
          </Menu>
        </Box>

         <Box minW="200px">
          <Text fontWeight="medium" mb={1}>Relationship to Subscriber</Text>
          <Menu closeOnSelect={false}>
            <MenuButton as={Button} width="100%">
              {filters?.relationShipToSubscriber?.length > 0
                ? `${filters?.relationShipToSubscriber?.length} Selected`
                : 'All Relationships'}
            </MenuButton>
            <MenuList p={0} minW="200px">
              <Box maxHeight="300px" overflowY="auto" px={0} py={2}>
                <CheckboxGroup
                  value={filters?.relationShipToSubscriber}
                   onChange={(values) => setFilters((prev:any)=>({...prev,relationShipToSubscriber:values}))}
                >
                  <VStack align="stretch" spacing={1}>
                    {[
                      "Mother",
                      "Father",
                      "Daughter",
                      "Son",
                      "Self",
                      "Sister",
                      "Brother",
                      "Grand Mother",
                      "Grand Father",
                      "Father-in-law",
                      "Mother-in-law",
                      "Spouse",
                      "Others"
                    ].map((relation) => (
                      <Flex key={relation} align="center" _hover={{ bg: 'gray.100' }} >
                        <Checkbox
                          ml={3}
                          value={relation}
                          isChecked={filters?.relationShipToSubscriber?.includes(relation)}
                          onChange={(e) => {
                            const value = relation;
                            if (e.target.checked) {
                              setFilters((prev: any) => ({
                                ...prev,
                                relationShipToSubscriber: [...filters?.relationShipToSubscriber, value],
                              }));
                            } else {
                              setFilters((prev: any) => ({
                                ...prev,
                                relationShipToSubscriber: filters?.relationShipToSubscriber.filter((v: any) => v !== value),
                              }));
                            }
                          }}
                        />
                        <Text fontSize="sm" ml={4}>{relation}</Text>
                      </Flex>
                    ))}
                  </VStack>
                </CheckboxGroup>
              </Box>

              <Flex borderTop="1px solid #e2e8f0" px={3} py={2} bg="white"  justifyContent="space-between">
                <Button
                  bg="blue"
                  color="white"
                  variant="ghost"
                  size="sm"
                  _hover={{ bg: 'gray.100' }}
                  onClick={() => {
                    menuStatusButtonRef.current?.click(); 
                  }}
                >
                  close
                </Button>
                 <Button
                  bg="blue"
                  color="white"
                  variant="ghost"
                  size="sm"
                  _hover={{ bg: 'gray.100' }}
                  onClick={()=>{
                     setFilters((prev: any) => ({
                                ...prev,
                                relationShipToSubscriber: [],
                              }))
                  }}
                >
                  reset
                </Button>
              </Flex>
            </MenuList>
          </Menu>
        </Box>

        {/* Date Filter */}
        <Box minW="250px">
          <Text fontWeight="medium" mb={2}>Date Filter</Text>
          <Flex gap={2}>
            <Box flex={1}>
              <Text fontSize="sm" mb={1}>Start Date</Text>
              <Input
                type="date"
                value={filters?.startDate}
                onChange={(e) => {
                  const value = e.target.value;
  
                  setFilters((prev: any) => ({ ...prev, startDate: value }));
                }}
              />
            </Box>
            <Box flex={1}>
              <Text fontSize="sm" mb={1}>End Date</Text>
              <Input
                type="date"
                value={filters?.endDate}
                onChange={(e) => {
                  const value = e.target.value;
              
                  setFilters((prev: any) => ({ ...prev, endDate: value }));
                }}
                min={filters.startDate}
              />
            </Box>
          </Flex>
        </Box>


        {/* Reset Button */}
        <Box>
          <Button onClick={resetFilters} variant="outline" colorScheme="gray">
            Reset Filters
          </Button>
        </Box>
      </Flex>

      {/* Table */}
      {loading ? (
        <Flex justify="center" align="center" minH="100px">
          <Spinner size="lg" color="blue.500" />
        </Flex>
      ) : data && data.length > 0 ? (
          <Table variant="simple" size="md">
            <Thead>
              <Tr>
                {data.some(item => item._id?.companyName) && <Th>Company Name</Th>}
                <Th>Ticket Status</Th>
                <Th>Ticket Type</Th>
                <Th>Relationship</Th>
                <Th>Count</Th>
                <Th>numberOfBothServicesCount</Th>
                <Th>numberOfDoctorCount</Th>
                <Th>numberOfAmbulanceCount</Th>
                {(filters?.startDate || filters?.endDate) && <Th>Date</Th>}
              </Tr>
            </Thead>
            <Tbody>
              {data.map((item, idx) => (
                <Tr key={idx}>
                  {data.some(item => item._id?.companyName) && <Td>{item._id?.companyName}</Td>}
                  <Td>{item._id?.status}</Td>
                  <Td>{item._id?.ticketType}</Td>
                  <Td>{item._id?.relationship}</Td>
                  <Td>{item.count}</Td>
                  <Td>{item?.numberOfBothServicesCount}</Td>
                  <Td>{item?.numberOfDoctorCount}</Td>
                  <Td>{item?.numberOfAmbulanceCount}</Td>
                  {(filters?.startDate || filters?.endDate) && (
                    <Td>{moment(item.date).format('YYYY-MM-DD')}</Td>
                  )}
                </Tr>
              ))}
              <Tr bg="gray.100" fontWeight="bold">
                <Td colSpan={data.some(item => item._id?.companyName) ? 4 : 3}>Total</Td>
                <Td>{total?.totalTickets}</Td>
                <Td>{total?.totalBothServicesCount}</Td>
                <Td>{total?.totalDoctorCount}</Td>
                <Td>{total?.totalAmbulanceCount}</Td>            
                {(filters?.startDate || filters?.endDate) && <Td>-</Td>}
              </Tr>
            </Tbody>
          </Table>

      ) : (
        <Flex justify="center" align="center" minH="100px">
          <p>No data available</p>
        </Flex>
      )}

    </Box>

  );
}

export default CustomTable;
